import {frontendApiClient} from "@/services/api";
import {LoginRequest} from "@/lib/definitions-requests";
import axios, {AxiosResponse} from "axios";
import {UserInfoResponse} from "@/lib/definitions-responses";

export const loginUser = async (request: LoginRequest): Promise<AxiosResponse | null> => {
    try {
        return await frontendApiClient.post("/account/login", request);
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const status = error.response?.status;

            if (status === 403) {
                // Возвращаем сам ответ, можно даже вернуть error.response, если нужно больше информации
                return error.response ?? null;
            }
        }

        console.error("Failed to login user:", error);
        throw new Error("Could not login user");
    }
};

export const logoutUser = async (): Promise<number> => {
    try {
        const response = await frontendApiClient.post("/account/logout");

        return response.status;
    } catch (error) {
        console.error("Failed to logout user:", error);
        throw new Error("Could not logout user");
    }
};

export const changeUserPassword = async (userId: string, password: string): Promise<number> => {
    try {
        const request = {
            password: password,
        };

        const response = await frontendApiClient.post(`/users/set-password/${userId}`, request);

        return response.status;
    } catch (error) {
        console.error("Failed to change user's password:", error);
        throw new Error("Failed to change user's password:");
    }
};

export const resetUserPassword = async (userId: string): Promise<number> => {
    try {
        const response = await frontendApiClient.get(`/users/reset-password/${userId}`);

        return response.status;
    } catch (error) {
        console.error("Failed to reset user's password:", error);
        throw new Error("Failed to reset user's password:");
    }
};

export const fetchUserInfo = async (): Promise<UserInfoResponse> => {
    try {
        const response = await frontendApiClient.get(`/account/me`);

        return response.data;
    } catch (error) {
        console.error("Failed to fetch user info:", error);
        throw new Error("Failed to fetch user info:");
    }
};